/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */
//  Indie Songs
// Hip-Hop
// Pop
// Bollywood
export const videos = [
  {
    _id: "fWBBjAeIZms",
    title:
      "Kammo Ji - 60's Bollywood Lo-fi | Recovering Pizza Addict | Hashparker Music",
    description: "Song Credits - Harsh Choudhary A.K.A. hashparkermusic    ",
    creator: "Recovering Pizza Addict",
    views: "24K",
    dateUploaded: "2 years ago",
    runTime: "2:49",
    alt: "song",
    thumbnailURL: "https://img.youtube.com/vi/fWBBjAeIZms/maxresdefault.jpg",
    avatar:
      "https://yt3.ggpht.com/OxFeKZ3gLeAASmR7uiv39-LTA8ShglraaYIGXscVNA03klS1RGesTtyp3IbwFv6gGmxhwoXc=s176-c-k-c0x00ffffff-no-rj",
    category: "Indie Songs",
  },
  {
    _id: "UfvQjcu0c48",
    title: "Umer Farooq - Teri Ay (Official Music Video)",
    description:
      "Umer Farooq - Teri Ay Album: Patang  Written, composed and performed by Umer FarooqProduced by Saad Sultan Directed by Raza Shah",
    creator: "Umer Farooq",
    views: "1.2M",
    dateUploaded: "3 Years ago",
    runTime: "3:55",
    alt: "song",
    thumbnailURL: "https://img.youtube.com/vi/UfvQjcu0c48/maxresdefault.jpg",
    avatar:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/videoLibrary/channelThumbnail/umer.jpg",
    category: "Indie Songs",
  },
  {
    _id: "WL-3zvnUomk",
    title: "Crew Love",
    description:
      " Provided to YouTube by Universal Music Group Crew Love · Drake · The Weeknd Take Care",
    creator: "Drake",
    views: "15M",
    dateUploaded: "10 year ago",
    runTime: "3:29",
    alt: "song",
    thumbnailURL: "https://img.youtube.com/vi/WL-3zvnUomk/maxresdefault.jpg",
    avatar:
      "https://yt3.ggpht.com/ytc/AKedOLRRnYQvFT7xYnEOtOhnEcDyheW8R5n6nTvRN3Nrvg=s900-c-k-c0x00ffffff-no-rj",
    category: "Hip-Hop",
  },
  {
    _id: "nDHFCZBM-lM",
    title:
      "Hey Ya ! Full Video Song | Karthik Calling Karthik | Farhan Akhtar, Deepika Padukone",
    description:
      "Presenting the full video song Hey Ya!  from the Bollywood movie 'Karthik Calling Karthik' featuring Farhan Akhtar, Deepika Padukone in the lead role. The song is sung by Loy Mendonca, Shankar Mahadevan, Clinton Cerejo, and the music is composed by Shankar Mahadevan, Ehsaan Noorani, Loy Mendonca. The lyrics are written by Javed Akhtar.",
    creator: "T-Series",
    views: "230K",
    dateUploaded: "10 year ago",
    runTime: "2:03",
    alt: "song",
    thumbnailURL: "https://img.youtube.com/vi/nDHFCZBM-lM/maxresdefault.jpg",
    avatar:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/videoLibrary/channelThumbnail/tseries.jpg",
    category: "Bollywood",
  },
  {
    _id: "1sLB79ElB40",
    title: "Abhin & Tanish - Kami Hai | Official Lyric Video",
    description:
      "This track revolves around the idea of contemplating reasons behind the absence of something/ somebody, understanding our contributing faults, facing our never departing regrets and embracing the permanent voids that are left behind.",
    creator: "Abhin & Tanish",
    views: "27k",
    dateUploaded: "1 year ago",
    runTime: "4:17",
    alt: "song",
    thumbnailURL: "https://img.youtube.com/vi/1sLB79ElB40/maxresdefault.jpg",
    avatar:
      "https://yt3.ggpht.com/ytc/AKedOLTstlj_L30bwLQ6A7NwCeYZdRtOJqP0Cu7MBP3M1Q=s900-c-k-c0x00ffffff-no-rj",
    category: "Indie Songs",
  },

  {
    _id: "Oge-Eaik0qY",
    title: "Raghav Meattle - City Life | Official Music Video",
    description:
      "City Life tries to depict life in Bombay - the hustle, bustle, grime and dust of the day, in contrast to the calm and emptiness of night. In its own way, the film is a tribute to Bombay, which thousands flock to everyday, like a moth to a bulb, unable to move itself away. The film was processed and developed at Andec Filmtechnik, Berlin.",
    creator: "Raghav Meattle",
    views: "333K",
    dateUploaded: "2 year ago",
    runTime: "2:57",
    alt: "song",
    thumbnailURL: "https://img.youtube.com/vi/Oge-Eaik0qY/maxresdefault.jpg",
    avatar:
      "https://yt3.ggpht.com/ytc/AKedOLTi6sxEpGZEQBWkZnEWKi2KQYMRrJewPI9KRA6onSA=s176-c-k-c0x00ffffff-no-rj",
    category: "Indie Songs",
  },
  {
    _id: "iyaJL9F5hsU",
    title:
      "Tu Hai Kahaan by Advait & Aman but it's the soundtrack for 'The Perks of Being a Wallflower' ",
    description:
      "Music Composed, Produced & Engineered by Advait Vocals Co Composed, Written & Performed by Aman",
    creator: "Advait",
    views: "378K",
    dateUploaded: "3 years ago",
    runTime: "3:00",
    alt: "song",
    thumbnailURL: "https://img.youtube.com/vi/iyaJL9F5hsU/maxresdefault.jpg",
    avatar:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/videoLibrary/channelThumbnail/advit.jpg",
    category: "Indie Songs",
  },
  {
    _id: "cqD2NWJuJO0",
    title: "Depression Jam - The Outro By The Voidz (Cover)",
    description:
      "I was feeling a bit down but then I started jamming and ended up feeling better -- nothing a good ol two five one four chord prog cant do for ya!!especially during these weird times of quarantine blues :P",
    creator: "Andres Cisneros",
    views: "63K",
    dateUploaded: "2 year ago",
    runTime: "4:54",
    alt: "song",
    thumbnailURL: "https://img.youtube.com/vi/cqD2NWJuJO0/maxresdefault.jpg",
    avatar:
      "https://yt3.ggpht.com/ytc/AKedOLQTTRj9JMWUDVQKTAjseeT3bNlOv2pr0RNHOvgS8Q=s176-c-k-c0x00ffffff-no-rj",
    category: "Pop",
  },
  {
    _id: "L1_iNHd69K0",
    title: "Jee Le Aaj (Acoustic Version) - Bharg Kale and Sez On The Beat",
    description:
      "Hey everyone! So I thought of releasing this old acoustic version of a song I did with Sez last year called Jee Le Aaj. I hope you do enjoy this rendition as much as my team and I do.",
    creator: "Bharg",
    views: "30K",
    dateUploaded: "1 year ago",
    runTime: "3:27",
    alt: "song",
    thumbnailURL: "https://img.youtube.com/vi/L1_iNHd69K0/maxresdefault.jpg",
    avatar:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/videoLibrary/channelThumbnail/bharg.jpg",
    category: "Indie Songs",
  },
  {
    _id: "T1iIIZtP_eE",
    title: "gigi - was it pog?",
    description:
      "SONG MADE BY king's scraps  https://soundcloud.com/boitheking/was... !! If you enjoyed the video be sure to 👍 Like and Subscribe! And turn on 🔔 Bell Notifications for when I post new videos! ",
    creator: "Pokelawls",
    views: "279k",
    dateUploaded: "1 year ago",
    runTime: "1:15",
    alt: "song",
    thumbnailURL: "https://img.youtube.com/vi/klZarL9tk9c/maxresdefault.jpg",
    avatar:
      "https://yt3.ggpht.com/ytc/AKedOLSgEOY2JmxgUDnUxkmNYl4oehi2y0_51GJR_ZhC3g=s176-c-k-c0x00ffffff-no-rj",
    category: "Pop",
  },
  {
    _id: "snXlkWuaOvI",
    title: "ASHWYN & Tyler Simmons Five Miles",
    description:
      "My new track with Tyler Simmons is finally out!! I had a blast making it and hope you guys enjoy this one!! Shoutout to Aaron Wolff for the awesome flute part!!",
    creator: "ASHWYN",
    views: "4K",
    dateUploaded: "2 years ago",
    runTime: "2:37",
    alt: "song",
    thumbnailURL: "https://img.youtube.com/vi/snXlkWuaOvI/maxresdefault.jpg",
    avatar:
      "https://yt3.ggpht.com/xoaD3J3hwdxNXrfE_Vv42F6lrKJ7BR3Si2aBfIdwaINxg8gIuk5mvEJ3-zuVQ4E7xCMY6OIKiw=s176-c-k-c0x00ffffff-no-rj",
    category: "Indie Songs",
  },
  {
    _id: "MTGimF6xgJg",
    title: "Friday AAA mix feat. CWC Music",
    description:
      "This video covers the vibes you have been missing on your weekends.",
    creator: "EMO BOIS",
    views: "200k",
    dateUploaded: "2 year ago",
    runTime: "1:09",
    alt: "song",
    thumbnailURL: "https://img.youtube.com/vi/MTGimF6xgJg/maxresdefault.jpg",
    avatar:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/videoLibrary/channelThumbnail/emo-boys.jpg",
    category: "Indie Songs",
  },
  {
    _id: "v-tjloemRzE",
    title: "Mere Tum - Neyhal ft. Karan Malhotra",
    description:
      "Singer-songwriter from Nagpur, #Neyhal debut song ‘Mere Tum’ is going to make you fall in love with his voice and writing! Neyhal first appeared on @Raghav Meattle's Conemunity, a late night Instagram LIVE show, and subsequently released his music through #BigIndieBang, a platform for young musicians in India.",
    creator: "Big Bang Music",
    views: "765K",
    dateUploaded: "2 years ago",
    runTime: "3:10",
    alt: "song",
    thumbnailURL: "https://img.youtube.com/vi/v-tjloemRzE/maxresdefault.jpg",
    avatar:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/videoLibrary/channelThumbnail/big-bang.jpg",
    category: "Indie Songs",
  },
  {
    _id: "vj7-6QTrCEk",
    title: "Naalayak - Haan Pyaar Hai(Official music video)",
    description:
      "Written and composed by : Sahil Samuel. Follow: https://instagram.com/sahilsamuel_?ig...",
    creator: "Naalayak",
    views: "2.4M",
    dateUploaded: "5 years ago",
    runTime: "5:02",
    alt: "song",
    thumbnailURL: "https://img.youtube.com/vi/vj7-6QTrCEk/maxresdefault.jpg",
    avatar:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/videoLibrary/channelThumbnail/naalayak.jpg",
    category: "Indie Songs",
  },

  {
    _id: "cVDASbWZ_KI",
    title: "Bharat Chauhan - Tu Hoti Toh [Official Music Video]",
    description:
      "Music video for Bharat Chauhan's Tu Hoti Toh filmed by The Perfect Shot",
    creator: "Bharat Chauhan",
    views: "1.6M",
    dateUploaded: "3 year ago",
    runTime: "5:45",
    alt: "song",
    thumbnailURL: "https://img.youtube.com/vi/cVDASbWZ_KI/maxresdefault.jpg",
    avatar:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/videoLibrary/channelThumbnail/bharat.jpg",
    category: "Indie Songs",
  },
];
